"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingSummary = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var billingSummary_1 = require("../../../../shared/api/mappings/billing/billingSummary");
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var section_ids_1 = require("../../section-ids");
var BillingSummaryUI_1 = require("./ui/BillingSummaryUI");
var Error_1 = require("./ui/components/EmptyStates/Error");
var Loading_1 = require("./ui/components/EmptyStates/Loading");
var WelcomeNoPeriods_1 = require("./ui/components/EmptyStates/WelcomeNoPeriods");
exports.BillingSummary = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var accountId = _a.accountId;
    return (react_1.default.createElement("div", { "data-testid": section_ids_1.BILLING_FETCHER.LEGACY },
        react_1.default.createElement(BillingSummaryLegacyFetcher, { accountId: accountId })));
}, Loading_1.Loading);
var BillingSummaryLegacyFetcher = function (_a) {
    var accountId = _a.accountId;
    var billingPeriodsQueryResult = (0, legacy_queries_1.useBillablePeriodsLegacyQuery)(accountId);
    var billingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, 'latest');
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { queryResults: [billingPeriodsQueryResult, billingQueryResult], NoData: Loading_1.Loading, Error: Error_1.Error, Data: Data }));
};
var Data = function (_a) {
    var _b = __read(_a.data, 2), billingPeriodsQueryResponse = _b[0], billingQueryResponse = _b[1];
    var history = (0, billingSummary_1.mapBillingSummaryLegacyToBillingSummaryCX)(billingPeriodsQueryResponse);
    return (react_1.default.createElement(BillingSummaryData, { currentPeriod: billingQueryResponse, historicalPeriods: history }));
};
var BillingSummaryData = function (_a) {
    var _b;
    var currentPeriod = _a.currentPeriod, historicalPeriods = _a.historicalPeriods;
    var retailer = core_1.configService.getConfig().retailer;
    var latestPeriod = (currentPeriod === null || currentPeriod === void 0 ? void 0 : currentPeriod.billingSummary) &&
        'latestPeriod' in currentPeriod.billingSummary
        ? currentPeriod.billingSummary.latestPeriod.data
        : null;
    var count = 0;
    var periodsToDisplay = new Array(4).fill(undefined).map(function (_, index) {
        var _a;
        if (index === 0 && latestPeriod) {
            var period = {
                startDate: latestPeriod.start,
                endDate: latestPeriod.end,
                totalCharges: {
                    gross: {
                        value: latestPeriod.totalCharge.grossCharge.pounds,
                        currency: retailer.currencyCode,
                    },
                },
                isStatementAvailable: latestPeriod.isStatementAvailable,
            };
            return period;
        }
        if (!historicalPeriods) {
            return undefined;
        }
        if ((latestPeriod === null || latestPeriod === void 0 ? void 0 : latestPeriod.start) === ((_a = historicalPeriods[count]) === null || _a === void 0 ? void 0 : _a.startDate)) {
            //If historialPeriod is the same as latestPeriod, skip it.
            count++;
            return historicalPeriods[count++];
        }
        return historicalPeriods[count++];
    });
    var isFirstBillablePeriodDuplicated = latestPeriod &&
        (historicalPeriods === null || historicalPeriods === void 0 ? void 0 : historicalPeriods.some(function (period) { return period.startDate === (latestPeriod === null || latestPeriod === void 0 ? void 0 : latestPeriod.start); }));
    var totalCompletedPeriods = !historicalPeriods
        ? 0
        : isFirstBillablePeriodDuplicated
            ? historicalPeriods.length - 1
            : historicalPeriods === null || historicalPeriods === void 0 ? void 0 : historicalPeriods.length;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_SUMMARY, properties: (_b = { status: 'error' }, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) }, !periodsToDisplay[0] ? (react_1.default.createElement(WelcomeNoPeriods_1.WelcomeNoPeriods, null)) : (react_1.default.createElement("div", null,
        react_1.default.createElement(BillingSummaryUI_1.BillingSummaryUI, { summaryPeriods: periodsToDisplay, totalCompletedPeriods: totalCompletedPeriods })))));
};
